import { markRaw } from 'vue';
import HeaderCarrierList from '@/shared/infrastructure/components/heading/HeaderCarrierList.vue';
import { useTranslation } from '@hfc/ui-core';

const { t } = useTranslation();

export default [
  {
    label: 'common.healthInsuranceOptions',
    href: '',
    description: null,
    customClass: '',
    prefixImg: '',
    subMenu: [
      {
        label: 'common.individual',
        href: '/individual-health-insurance',
        description: null,
        customClass: '',
        prefixImg: '',
        subMenu: []
      },
      {
        label: 'common.family',
        href: `/${t('links.familyHealthPlans')}`,
        description: null,
        customClass: '',
        prefixImg: '',
        subMenu: []
      },
      {
        label: 'common.smallBusiness',
        href: '/group-health-insurance',
        description: null,
        customClass: '',
        prefixImg: '',
        subMenu: []
      },
      {
        label: 'common.seniorPlans',
        href: '/senior-health-insurance-options',
        description: null,
        customClass: '',
        prefixImg: '',
        subMenu: []
      },
      {
        label: 'common.travelInsurance',
        href: '/travel-health-insurance',
        description: null,
        customClass: '',
        prefixImg: '',
        subMenu: []
      },
      {
        label: 'common.newborn',
        href: '/newborn-health-insurance-ca-coverage',
        description: null,
        customClass: '',
        prefixImg: '',
        subMenu: []
      },
      {
        label: 'common.supplementalHealthPlans',
        href: '/supplemental-plans',
        description: null,
        customClass: '',
        prefixImg: '',
        subMenu: []
      },
      {
        label: 'Medi-Cal',
        href: '/covered-california/health-insurance-companies/medi-cal',
        description: null,
        customClass: '',
        prefixImg: '',
        subMenu: []
      }
    ]
  },
  {
    label: 'common.metallicPlans',
    href: '/covered-california/plans',
    description: null,
    customClass: 'min-w-[540px]',
    prefixImg: '',
    subMenu: [
      {
        label: 'Bronze',
        href: '/covered-california/plans/bronze',
        description: null,
        customClass: '',
        prefixImg: '/assets/img/plans/bronze.webp',
        subMenu: []
      },
      {
        label: 'Silver',
        href: '/covered-california/plans/silver',
        description: null,
        customClass: '',
        prefixImg: '/assets/img/plans/silver.webp',
        subMenu: []
      },
      {
        label: 'Gold',
        href: '/covered-california/plans/gold-80',
        description: null,
        customClass: '',
        prefixImg: '/assets/img/plans/gold.webp',
        subMenu: []
      },
      {
        label: 'Platinum',
        href: '/covered-california/plans/platinum-90',
        description: null,
        customClass: '',
        prefixImg: '/assets/img/plans/platinum.webp',
        subMenu: []
      },
      {
        label: 'common.minimumCoverage',
        href: '/covered-california/plans/minimum-coverage',
        description: null,
        customClass: '',
        prefixImg: '/assets/img/plans/catastrophic.webp',
        subMenu: []
      },
    ]
  },
  {
    label: 'common.healthInsuranceProviders',
    href: '/covered-california/health-insurance-companies',
    description: null,
    customClass: '',
    customComponent: markRaw(HeaderCarrierList),
    prefixImg: '',
    subMenu: []
  }];
